theme.headerSticky = (function() {
  function ScrollSticky(e){
    // .header__area faellt seit dem permanent fixierten Header (siehe
    // sections/header.liquid) ohne sein Kind im Fluss auf 0px zusammen --
    // .header__sticky selbst bleibt korrekt messbar (dieselbe Korrektur wie
    // bereits in sections/header.liquid und assets/header-drawer.js).
    const headerStickyTarget = document.querySelector('.header__sticky');
    const headerStickyWrapper = headerStickyTarget || document.querySelector('.header__area');

    if(headerStickyTarget){
      let headerHeight = headerStickyWrapper.clientHeight;
      window.addEventListener('scroll', function(){
        let StickyTargetElement = TopOffset(headerStickyWrapper);
        let TargetElementTopOffset = StickyTargetElement.top;
        if(window.scrollY > headerHeight ){
          headerStickyTarget.classList.add('sticky');
        }else{
          headerStickyTarget.classList.remove('sticky');
        }
      })
    }
    
    
  }
  return ScrollSticky;
})();


